import { useLayoutEffect, useState } from "react";

// material-ui
import { useTheme } from "@mui/material/styles";
import { Box, useMediaQuery } from "@mui/material";

// project import
import NavGroup from "./NavGroup";
import menuItem from "menu-items";

import { useSelector } from "store";
import useConfig from "hooks/useConfig";
import { HORIZONTAL_MAX_ITEM } from "config";

// types
import { NavItemType } from "types/menu";
import { MenuOrientation } from "types/config";
import { UserProfile } from "types/auth";
import useAuth from "hooks/useAuth";
import { USER_ROLE } from "utils/Constants";

// ==============================|| DRAWER CONTENT - NAVIGATION ||============================== //

const Navigation = () => {
  const theme = useTheme();
  const { user } = useAuth();

  const downLG = useMediaQuery(theme.breakpoints.down("lg"));

  const { menuOrientation } = useConfig();
  const { drawerOpen } = useSelector((state) => state.menu);
  const [selectedItems, setSelectedItems] = useState<string | undefined>("");
  const [selectedLevel, setSelectedLevel] = useState<number>(0);
  const [menuItems, setMenuItems] = useState<{ items: NavItemType[] }>({
    items: [],
  });

  useLayoutEffect(() => {
    setMenuItems(menuItem);
    // eslint-disable-next-line
  }, [menuItem]);

  const isHorizontal =
    menuOrientation === MenuOrientation.HORIZONTAL && !downLG;

  const lastItem = isHorizontal ? HORIZONTAL_MAX_ITEM : null;
  let lastItemIndex = menuItems.items.length - 1;
  let remItems: NavItemType[] = [];
  let lastItemId: string;

  //  first it checks menu item is more than giving HORIZONTAL_MAX_ITEM after that get lastItemid by giving horizontal max
  // item and it sets horizontal menu by giving horizontal max item lastly slice menuItem from array and set into remItems

  if (lastItem && lastItem < menuItems.items.length) {
    lastItemId = menuItems.items[lastItem - 1].id!;
    lastItemIndex = lastItem - 1;
    remItems = menuItems.items
      .slice(lastItem - 1, menuItems.items.length)
      .map((item) => ({
        title: item.title,
        elements: item.children,
        icon: item.icon,
      }));
  }

  // const navGroups = menuItems.items.slice(0, lastItemIndex + 1).map((item) => {
  //   switch (item.type) {
  //     case "group":
  //       return (
  //         <NavGroup
  //           key={item.id}
  //           setSelectedItems={setSelectedItems}
  //           setSelectedLevel={setSelectedLevel}
  //           selectedLevel={selectedLevel}
  //           selectedItems={selectedItems}
  //           lastItem={lastItem!}
  //           remItems={remItems}
  //           lastItemId={lastItemId}
  //           item={item}
  //         />
  //       );
  //     default:
  //       return (
  //         <Typography key={item.id} variant="h6" color="error" align="center">
  //           Fix - Navigation Group
  //         </Typography>
  //       );
  //   }
  // });

  const getAllowedNavigationItems = (
    menuItems: { items: NavItemType[] },
    user?: UserProfile | null
  ): NavItemType[] => {
    const allMenuItems = menuItems.items.slice(0, lastItemIndex + 1)[0]
      ?.children;
    const allowedNavigationItems: NavItemType[] = [];
    const allPermissions = {
      users_permissions: [
        {
          name: USER_ROLE.ADMIN,
          permissions: [
            "users",
            "adminStores",
            "dashboard",
            "adminNotifications",
            "error-reporting",
          ],
        },
        {
          name: USER_ROLE.USER,
          permissions: [
            "stores",
            "add-store",
            "notifications",
            "help_and_docs",
          ],
        },
      ],
    };
    // console.log("userr", user);

    if (user && allMenuItems) {
      const userPermissions: string[] | undefined =
        allPermissions.users_permissions.find(
          (eachPermission) => eachPermission.name === user.role
        )?.permissions;

      allMenuItems.forEach((eachMenuItem) => {
        switch (eachMenuItem.id) {
          case "users": {
            userPermissions?.some((eachPermission) => {
              return ["users"].includes(eachPermission);
            }) && allowedNavigationItems.push({ ...eachMenuItem });

            break;
          }
          case "dashboard": {
            userPermissions?.some((eachPermission) => {
              return ["dashboard"].includes(eachPermission);
            }) && allowedNavigationItems.push({ ...eachMenuItem });

            break;
          }
          case "adminStores": {
            userPermissions?.some((eachPermission) => {
              return ["adminStores"].includes(eachPermission);
            }) && allowedNavigationItems.push({ ...eachMenuItem });

            break;
          }
          case "stores": {
            userPermissions?.some((eachPermission) =>
              ["stores"].includes(eachPermission)
            ) && allowedNavigationItems.push({ ...eachMenuItem });

            break;
          }
          case "add-store": {
            userPermissions?.some((eachPermission) =>
              ["add-store"].includes(eachPermission)
            ) && allowedNavigationItems.push({ ...eachMenuItem });

            break;
          }
          case "notifications": {
            userPermissions?.some((eachPermission) =>
              ["notifications"].includes(eachPermission)
            ) && allowedNavigationItems.push({ ...eachMenuItem });

            break;
          }
          case "adminNotifications": {
            userPermissions?.some((eachPermission) =>
              ["adminNotifications"].includes(eachPermission)
            ) && allowedNavigationItems.push({ ...eachMenuItem });

            break;
          }
          case "error-reporting": {
            userPermissions?.some((eachPermission) =>
              ["error-reporting"].includes(eachPermission)
            ) && allowedNavigationItems.push({ ...eachMenuItem });

            break;
          }
          case "help_and_docs": {
            userPermissions?.some((eachPermission) =>
              ["help_and_docs"].includes(eachPermission)
            ) && allowedNavigationItems.push({ ...eachMenuItem });

            break;
          }
          default:
            break;
        }
      });

      const dummyMenuItems = JSON.parse(JSON.stringify(menuItems));
      dummyMenuItems.items.slice(0, lastItemIndex + 1)[0].children =
        allowedNavigationItems;

      return dummyMenuItems.items;
    }
    return [];
  };

  return (
    <Box
      sx={{
        pt: drawerOpen ? (isHorizontal ? 0 : 2) : 0,
        "& > ul:first-of-type": { mt: 0 },
        display: isHorizontal ? { xs: "block", lg: "flex" } : "block",
      }}
    >
      {getAllowedNavigationItems(menuItems, user).map((item) => {
        return (
          <NavGroup
            key={item.id}
            setSelectedItems={setSelectedItems}
            setSelectedLevel={setSelectedLevel}
            selectedLevel={selectedLevel}
            selectedItems={selectedItems}
            lastItem={lastItem!}
            remItems={remItems}
            lastItemId={lastItemId}
            item={item}
          />
        );
      })}
    </Box>
  );
};

export default Navigation;
